import { useTranslation } from "react-i18next";
import { conversationRowUnreadLabel } from "../conversation-list-row.js";

/** Mint "New messages" rule; with a count when it is pinned above older, unloaded unread messages. */
export function ConversationUnreadSeparator({ count }: { count?: number }): React.JSX.Element {
  const { t } = useTranslation();
  const countLabel = count == null ? null : conversationRowUnreadLabel(count);
  return (
    <li
      className="my-2.5 flex list-none items-center gap-2.5 text-[0.71875rem] font-semibold text-primary before:h-px before:flex-1 before:bg-[#b9e1d3] after:h-px after:flex-1 after:bg-[#b9e1d3]"
      data-testid="thread-unread-separator"
    >
      <span className="rounded-full bg-brand-mint px-2.5 py-0.5">
        {countLabel ? t("inbox.thread.newMessagesCount", { value: countLabel }) : t("inbox.thread.newMessages")}
      </span>
    </li>
  );
}
